"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  return {
    Item: {
      cursor: 'pointer',
      padding: [9, 13, 9, 13],
      fontSize: 12,
      lineHeight: 'initial',
      color: theme['$text-color'],
      fontWeight: 500,
      fontFamily: theme['$font-default'],
      display: 'flex',
      gap: '5px',
      alignItems: 'center',
      '&:hover': {
        textDecoration: 'underline'
      },
      '&.selected': {
        background: theme['$pillselection-selected'],
        borderRadius: '100px',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)'
      }
    },
    Disabled: {
      pointerEvents: 'none',
      color: "".concat(theme['$panel-background-color'])
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map